const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfProgress extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfProgress,
            "Each civilization scores 2 culture per level of each of its government and special (blue) technologies.",
            {}
        )
    }
}

module.exports = ImpactOfProgress;